import { render, staticRenderFns } from "./ProcessingReadinessBanner.vue?vue&type=template&id=0f4bfe62"
import script from "./ProcessingReadinessBanner.vue?vue&type=script&lang=js"
export * from "./ProcessingReadinessBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports